import React from "react";
import { Box } from "@chakra-ui/react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Solutions from "./components/Solutions";
import WhyChooseUs from "./components/WhyChooseUs";
import Partners from "./components/Partners";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function App() {
  return (
    <Box>
      <Navbar />
      <Hero />
      <About />
      <Solutions />
      <WhyChooseUs />
      <Partners />
      <Gallery />
      <Contact />
      <Footer />
    </Box>
  );
}
